export type PreservedReturnNavigationOptions = {
  // Disallow restoring to any path that starts with one of these prefixes
  disallowStartsWith?: string[];
  fallback?: string;
  queryKeys?: string[];
};

export type NavigationReturnState = {
  returnTo?: { pathname?: string; search?: string; hash?: string };
  from?: string;
};

export const defaultOptions: Required<PreservedReturnNavigationOptions> = {
  disallowStartsWith: ["/login", "/signup", "/auth"],
  fallback: "/",
  queryKeys: ["next", "returnTo", "redirect", "r"],
};
